export default "/images/globe.svg?d785106e9c6bb94cf973595bcdf75f48";